import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './Header';
import Home from './Home';
import Menu from './Menu';
import Footer from './Footer';
import SystemAlerts from "./SystemAlerts";
import Register from './Register';
import ChangePassword from './ChangePassword';
import Login from './Login';

import PatientRegister from './Patient/PatientRegister';
import PatSearch from './Patient/PatSearch';
import PatRegisterSearch from './Patient/PatRegisterSearch';
import EditPatient from './Patient/EditPatient';

//Other
import MasterMenu from './Other/MasterMenu';
import ComposeMessage from './Other/ComposeMessage';
import News from './Other/News';
import AddDept from './Other/AddDept';
import AddDesignation from './Other/AddDesignation';
import GenerateBarcode from './Other/GenerateBarcode';
import Support from './Other/Support';
import AddTemplate from './Other/AddTemplate';
import EditTemplate from './Other/EditTemplate';
import MisMenu from './Other/MisMenu';
import MisCollection from './Other/MisCollection';
//Pharmacy
import PharmMenu from './Pharmacy/PharmMenu';
import PharmStore from './Pharmacy/PharmStore';
import DrugView from './Pharmacy/DrugView';
import DrugPayOther from './Pharmacy/DrugPayOther';
import DrugPaySaved from './Pharmacy/DrugPaySaved';
import DrugPayRefill from './Pharmacy/DrugPayRefill';
import PharmInvoiceOther from './Pharmacy/PharmInvoiceOther';
import PharmInvoiceIndent from './Pharmacy/PharmInvoiceIndent';
import SalesReturn from './Pharmacy/SalesReturn';
import PharmInvoiceReturn from './Pharmacy/PharmInvoiceReturn';
import DrugPayDr from './Pharmacy/DrugPayDr';
import RaiseIndent from './Pharmacy/RaiseIndent';
import DrugPayIndent from './Pharmacy/DrugPayIndent';
import GrnEntry from './Pharmacy/GrnEntry';
import ReGrnEntry from './Pharmacy/ReGrnEntry';
import GrnList from './Pharmacy/GrnList';
import GrnInvoice from './Pharmacy/GrnInvoice';
import PoList from './Pharmacy/PoList';
import PoInvoice from './Pharmacy/PoInvoice';
import InternalReturn from './Pharmacy/InternalReturn';
import PurchaseReturn from './Pharmacy/PurchaseReturn';
import PurchaseInvoiceReturn from './Pharmacy/PurchaseInvoiceReturn';
import OtDrugList from './Pharmacy/OtDrugList';
import DrugPayOt from './Pharmacy/DrugPayOt';
import DrugPayIp from './Pharmacy/DrugPayIp';
import DrugIpPay from './Pharmacy/DrugIpPay';
import VendorSearch from './Pharmacy/VendorSearch';
import VendorPayment from './Pharmacy/VendorPayment';
import AddDrugGeneric from './Pharmacy/AddDrugGeneric';
import PharmPurchaseRequestEntry from './Pharmacy/PharmPurchaseRequestEntry';
import PharmPRList from './Pharmacy/PharmPRList';
import PharmRFQEntry from './Pharmacy/PharmRFQEntry';
import PharmRFQList from './Pharmacy/PharmRFQList';
import PharmVendorQuotationEntry from './Pharmacy/PharmVendorQuotationEntry';
import PharmVendorQuoteList from './Pharmacy/PharmVendorQuoteList';
import PharmAuditTrailList from './Pharmacy/PharmAuditTrailList';
import PharmApprovalLogList from './Pharmacy/PharmApprovalLogList';
import PharmApprovalLogView from './Pharmacy/PharmApprovalLogView';
import PharmVendorQuotationView from './Pharmacy/PharmVendorQuotationView';
import PharmQuotationCompare from './Pharmacy/PharmQuotationCompare';
import PharmPurchaseOrderCreate from './Pharmacy/PharmPurchaseOrderCreate';
import PharmPurchaseOrderView from './Pharmacy/PharmPurchaseOrderView';
import PharmPoList from './Pharmacy/PharmPoList';
import PharmacyGSTBulkUpdate from './Pharmacy/PharmacyGSTBulkUpdate';
//Pharmacy Masters
import AddManufacturer from './Pharmacy/AddManufacturer';
import EditManufacturer from './Pharmacy/EditManufacturer';
import AddDistributor from './Pharmacy/AddDistributor';
import EditDistributor from './Pharmacy/EditDistributor';
import DrugList from './Pharmacy/DrugList';
import ExpiryList from './Pharmacy/ExpiryList';
import IndentExpiryList from './Pharmacy/IndentExpiryList';
import IndentDrugList from './Pharmacy/IndentDrugList';
import EditDrug from './Pharmacy/EditDrug';
import EditGeneric from './Pharmacy/EditGeneric';
import EditIndentDrug from './Pharmacy/EditIndentDrug';
import AddNewProduct from './Pharmacy/AddNewProduct';
//Phamrcy Reports
import PharmCollectionAll from './Pharmacy/PharmCollectionAll';
import SaleReturnReport from './Pharmacy/SaleReturnReport';
import PharmDetail from './Pharmacy/PharmDetail';
import SalesGstReport from './Pharmacy/SalesGstReport';
import DetailSalesGstReport from './Pharmacy/DetailSalesGstReport';
import SalesGstStat from './Pharmacy/SalesGstStat';
import PurchaseReturnReport from './Pharmacy/PurchaseReturnReport';
import VendorPayReport from './Pharmacy/VendorPayReport';
import DiReport from './Pharmacy/DiReport';
import ScheduleReport from './Pharmacy/ScheduleReport';
import DrugFlow from './Pharmacy/DrugFlow';
import PurchaseGstReport from './Pharmacy/PurchaseGstReport';
import PurchaseGstStat from './Pharmacy/PurchaseGstStat';
import PatientDrugFlow from './Pharmacy/PatientDrugFlow';
import ClosingStatement from './Pharmacy/ClosingStatement';
import AbcAnalysis from './Pharmacy/AbcAnalysis';
import DailyConsolidate from './Pharmacy/DailyConsolidate';
import PharmProfit from './Pharmacy/PharmProfit';
//Speech Text
import SpeechText from './Other/SpeechText';
import Events from './Other/Events';
import ToDo from './Other/ToDo';
import EditToDo from './Other/EditToDo';
import FloatingChatbot from './Other/FloatingChatbot';

import {AuthProvider} from '../context/AuthContext';
import PrivateRoute from './PrivateRoute';
import { useState } from 'react';


function Main() {
  const location = useLocation();

  // Hide chatbot on login page
  const showChatbot = location.pathname !== "/user-login";
  return (
    <div className="App">
             <AuthProvider>
               <Header />
               <Routes>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'PharmacyStore']}/>}>
                        <Route path="/user-register" element={<Register />}  />
                        <Route path="/master-menu" element={<MasterMenu />} />
                        <Route path="/mis-menu" element={<MisMenu />} />
                        <Route path="/add-department" element={<AddDept />} />
                         
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Pharmacy', 'PharmacyStore']}/>}>
                        <Route path="/pharm-menu" element={<PharmMenu />} />
                        <Route path="/pharm-store" element={<PharmStore />} />
                    //Pharmacy
                        <Route path="/drug-view" element={<DrugView />} />
                        <Route path="/drug-pay-other/:pat_id" element={<DrugPayOther />} />

                        <Route path="/drug-pay-dr/:did" element={<DrugPayDr />} />
                        <Route path="/drug-pay-save/:did" element={<DrugPaySaved />} />
                        <Route path="/drug-refill/:did" element={<DrugPayRefill />} />
                        <Route path="/sales-return/:sale_pharm" element={<SalesReturn />} />
                        <Route path="/pharm-invoice-return/:sale_return/" element={<PharmInvoiceReturn />} />

                        <Route path="/grn-entry" element={<GrnEntry />} />
                        <Route path="/re-grnentry/:grn_id/" element={<ReGrnEntry />} />
                        <Route path="/grn-list" element={<GrnList />} />
                        <Route path="/grn-invoice/:grn_id/" element={<GrnInvoice />} />
                        <Route path="/po-list" element={<PoList />} />
                        <Route path="/po-invoice/:grn_id/" element={<PoInvoice />} />
                        <Route path="/internal-return" element={<InternalReturn />} />
                        <Route path="/purchase-return" element={<PurchaseReturn />} />
                        <Route path="/purchase-return-invoice/:pur_return" element={<PurchaseInvoiceReturn />} />
                        <Route path="/alerts" element={<SystemAlerts />} />


                        <Route path="/pharm-pur-req-entry" element={<PharmPurchaseRequestEntry />} />
                        <Route path="/pharm-pur-req-list" element={<PharmPRList />} />
                        <Route path="/pharm-rfq-entry" element={<PharmRFQEntry />} />
                        <Route path="/pharm-rfq-ent-list" element={<PharmRFQList />} />
                        <Route path="/pharm-vendor-quote" element={<PharmVendorQuotationEntry />} />
                        <Route path="/pharm-vendor-quotation-view/:id/" element={<PharmVendorQuotationView />} />
                        <Route path="/pharm-quotation-compare" element={<PharmQuotationCompare />} />
                        <Route path="/pharm-po-create" element={<PharmPurchaseOrderCreate />} />
                        <Route path="/pharm-po-view/:id/" element={<PharmPurchaseOrderView />} />
                        <Route path="/pharm-vendor-quote-list" element={<PharmVendorQuoteList />} />
                        <Route path="/pharm-approve-log-list" element={<PharmApprovalLogList />} />
                        <Route path="/pharm-audit-trail-list" element={<PharmAuditTrailList />} />
                        <Route path="/pharm-approve-log-view/:id/" element={<PharmApprovalLogView />} />
                        <Route path="/pharm-po-list" element={<PharmPoList />} />
                        <Route path="/gst-upload" element={<PharmacyGSTBulkUpdate />} />
                        //Patient
                        <Route path="/add-patient" element={<PatientRegister />} />
                        <Route path="/edit-patient/:patId" element={<EditPatient />} />

                        <Route path="/vendor-search" element={<VendorSearch />} />
                        <Route path="/vendor-payment/:dist_id/" element={<VendorPayment />} />
                        //Pharmacy Masters
                        <Route path="/add-manufacturer" element={<AddManufacturer />} />
                        <Route path="/edit-manufacturer/:id" element={<EditManufacturer />} />
                        <Route path="/add-distributor" element={<AddDistributor />} />
                        <Route path="/edit-distributor/:id" element={<EditDistributor />} />
                        <Route path="/drug-list" element={<DrugList />} />
                        <Route path="/expiry-list" element={<ExpiryList />} />
                        <Route path="/indent-expiry-list" element={<IndentExpiryList />} />
                        <Route path="/indent-drug-list" element={<IndentDrugList />} />
                        <Route path="/edit-pharm/:id/" element={<EditDrug />} />
                        <Route path="/edit-generic/:id/" element={<EditGeneric />} />
                        <Route path="/edit-indent/:id/" element={<EditIndentDrug />} />
                        <Route path="/drug-generic" element={<AddDrugGeneric />} />
                        <Route path="/add-new-product" element={<AddNewProduct />} />
                        //Pharmacy Reports
                        <Route path="/pharm-collection-all" element={<PharmCollectionAll />} />
                        <Route path="/sale-return-report" element={<SaleReturnReport />} />
                        <Route path="/detail-sales" element={<PharmDetail />} />
                        <Route path="/sales-gst-report" element={<SalesGstReport />} />
                        <Route path="/detail-sales-gst-report" element={<DetailSalesGstReport />} />
                        <Route path="/sales-gst-stat" element={<SalesGstStat />} />
                        <Route path="/purchase-return-report" element={<PurchaseReturnReport />} />
                        <Route path="/vendor-pay-report" element={<VendorPayReport />} />
                        <Route path="/di-report" element={<DiReport />} />
                        <Route path="/schedule-report" element={<ScheduleReport />} />
                        <Route path="/drug-flow" element={<DrugFlow />} />
                        <Route path="/purchase-gst-report" element={<PurchaseGstReport />} />
                        <Route path="/purchase-gst-stat" element={<PurchaseGstStat />} />
                        <Route path="/pat-drug-flow" element={<PatientDrugFlow />} />
                        <Route path="/closing-statement" element={<ClosingStatement />} />
                        <Route path="/abc-analysis" element={<AbcAnalysis />} />
                        <Route path="/daily-consolidate" element={<DailyConsolidate />} />
                        <Route path="/pharm-profit" element={<PharmProfit />} />
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Pharmacy', 'PharmacyStore']}/>}>
                        <Route path="/pharm-invoice-other/:sale_pharm/" element={<PharmInvoiceOther />} />
                        <Route path="/ot-drug-list" element={<OtDrugList />} />
                        <Route path="/drug-pay-ot/:ip_id" element={<DrugPayOt />} />
                        <Route path="/drug-pay-ip/:ip_id" element={<DrugPayIp />} />
                        <Route path="/drug-ip-pay/:did" element={<DrugIpPay />} />
                        <Route path="/raise-indent" element={<RaiseIndent />} />
                        <Route path="/drug-pay-indent/:did" element={<DrugPayIndent />} />
                        <Route path="/pharm-invoice-indent/:sale_pharm/" element={<PharmInvoiceIndent />} />
                    </Route>
                    
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Pharmacy', 'PharmacyStore']}/>}>
                        <Route path="/" element={<Home />}  exact />
                        <Route path="/support" element={<Support />} />
                        <Route path="/change-password" element={<ChangePassword />}  />
                        <Route path="/admin-menu" element={<Menu />} />

                        <Route path="/news" element={<News />} />
                        <Route path="/comp-mess" element={<ComposeMessage />} />
                      
                        <Route path="/speech" element={<SpeechText />} />
                        <Route path="/events" element={<Events />} />
                        <Route path="/todolist" element={<ToDo />} />
                        <Route path="/edit-todolist/:id" element={<EditToDo />} />
                    </Route>

                    <Route path="/user-login" element={<Login />} />
               </Routes>
                 {showChatbot && <FloatingChatbot />}
             </AuthProvider>
             <Footer />

    </div>
  );
}
export default Main;
